<section aria-labelledby="privacy_page_heading" class="main-container">
  @if (!isOpenedFromGuest) {
    <h4 id="privacy_page_heading" class="uppercase text-w-700 center">
      {{ multilingualService.langMap?.LABEL_PRIVACY_POLICY }}
    </h4>
  }
  @if (privacyPolicy) {
    <div class="custom-box padding-box">
      <p [innerHtml]="privacyPolicy.content"></p>
    </div>
  }
  @if (isLoading) {
    <div aria-busy="true" role="status" class="center loader-circle">
      <img imageName="loader.gif" [common]="true" alt="loader" width="80px" />
    </div>
  }

  @if (isError && !isLoading) {
    <div class="error-mesg mb-2 empty-box-height">
      <div>
        <img
          aria-hidden="true"
          imageName="something-went-wrong.svg"
          alt="Something went wrong"
          width="100px"
        />
        <p role="alert" class="title-10 text-w-700">{{ errMsg }}</p>
      </div>
    </div>
  }
</section>
